import { Box, Typography } from '@mui/material';
import { Button } from '@uy3/web-components';
import { formatCustomDate } from 'helpers';

interface ActionButtonConfig {
    label: string;
    onClick?: () => void;
    variant?: 'contained' | 'outlined';
    disabled?: boolean;
}

interface ActionButtonsProps {
    lastUpdate?: string | Date;
    buttons: ActionButtonConfig[];
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({ lastUpdate, buttons }) => (
    <Box
        sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'end',
            backgroundColor: '#F4F3F3',
            borderRadius: 2,
            height: 64,
            gap: 5,
            p: 1.5
        }}
    >
        <Typography
            variant="body2"
            color="neutral.500"
            sx={{
                fontFamily: 'Lato, sans-serif',
                fontWeight: 400,
                fontSize: 14,
                alignSelf: 'center'
            }}
        >
            Última atualização: {formatCustomDate(lastUpdate as string)}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
            {buttons.map((btn, idx) => (
                <Button
                    key={btn.label + idx}
                    size="medium"
                    sx={{
                        height: 40,
                        borderRadius: 2
                    }}
                    variant={btn.variant || 'contained'}
                    disabled={btn.disabled}
                    onClick={btn.onClick}
                >
                    {btn.label}
                </Button>
            ))}
        </Box>
    </Box>
);
